import React from 'react';
import { SURTITRE } from '../../ui/pills';

/**
 * Carte de section de la fiche-dossier (maquette 18a) : rayon 12, bordure, fond surface, sur-titre en
 * capitales et, à droite, une phrase d'explication facultative. Même enveloppe pour toutes les sections
 * — c'est ce qui donne à la page un rythme unique au lieu du mélange de styles d'avant (demande d'Emeni,
 * 2026-09-02 : « on se perd dans les informations »).
 */
export function Carte({ titre, aside, id, className = '', children }: {
    titre: React.ReactNode;
    aside?: React.ReactNode;
    id?: string;
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <section id={id} className={`p-4 rounded-xl border border-border bg-surface scroll-mt-4 ${className}`}>
            <div className="flex items-baseline justify-between gap-2.5 flex-wrap mb-3">
                <span className={`${SURTITRE} shrink-0`}>{titre}</span>
                {aside && <span className="text-[11.5px] text-content-muted">{aside}</span>}
            </div>
            {children}
        </section>
    );
}

/** Liste « clé à gauche, valeur en gras à droite », un trait léger entre chaque ligne. */
export function Faits({ lignes }: { lignes: [React.ReactNode, React.ReactNode][] }) {
    return (
        <div className="flex flex-col">
            {lignes.map(([k, v], i) => (
                <div key={i} className={`flex items-baseline justify-between gap-3.5 py-2 ${i > 0 ? 'border-t border-border-soft' : ''}`}>
                    <span className="text-[12px] text-content-muted shrink-0">{k}</span>
                    <span className="text-[12.5px] font-semibold text-content text-right min-w-0 break-words">{v}</span>
                </div>
            ))}
        </div>
    );
}

/** Grille de cartes qui passe en une colonne sous 300 px par carte. */
export const GRILLE_2 = 'grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-3 items-start';
